export interface ChecklistItem {
  id: string;
  label: string;
  completed: boolean;
  actionLabel?: string;
  onAction?: () => void;
  isPrimary?: boolean;
}

export interface SiteSetupProps {
  progress: number;
  totalSteps: number;
  websiteInfo: {
    domain: string;
    storageType: string;
  };
  checklist: ChecklistItem[];
  showEmptyState?: boolean;
  onEditWebsite?: () => void;
  emptyStateConfig?: {
    title_one?: string;
    title_two?: string;
    buttonLabel?: string;
    onCreate?: () => void;
    icon?: string;
  };
}

export const defaultEmptyStateConfig = [
  {
    id: "create-domain",
    label: "Create a Domain",
    completed: true,
  },
  {
    id: "edit-website",
    label: "Edit your website",
    completed: true,
  },
  {
    id: "publish-site",
    label: "Publish your Site",
    completed: false,
    actionLabel: "Publish Now",
    isPrimary: true,
    onAction: () => {},
  },
  {
    id: "create-article",
    label: "Create a article",
    completed: false,
    actionLabel: "Create Now",
    isPrimary: true,
    onAction: () => {},
  },
  {
    id: "site-theme",
    label: "Site Theme",
    completed: true,
  },
  {
    id: "add-admin",
    label: "Add Admin",
    completed: true,
  },
];
